import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaNoTwo = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista No. 2"
        subTitle="(Rapid-1 Quick Setting/Hardening Compound for Cement Mortar & Concrete)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista No. 2"
          imageUrl={imgnotavailableImg}
          title="Description"
          content="Vista No. 2 is an extra-fast setting, waterproof plugging compound in liquid form. It is a time-tested liquid admixture designed for emergency or immediate repair work, including instant leak plugging and quick nozzle fixing applications."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista No. 2 is widely used for emergency repairs and instant leak plugging. Ideal for use in basements, pipe joints, retaining walls, tunnels, and sewerage systems where water is seeping or pouring under pressure." />
          <CustomLists
            items={[
              [
                "High-performance plugging compound with consistent results.",
                "Achieves high early strength—plugging completes within 5 minutes.",
              ],
              ["Simple application process.", "Excellent adhesion to substrates."],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Reliable, consistent setting and sealing performance.",
                "Quick setting—seals leaks within 30–60 seconds under pressure.",
              ],
              ["User-friendly application.", "Strong bonding with cement surfaces."],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", "Reddish Liquid"],
                ["Specific Gravity", "1.25 ± 0.02"],
                ["SP.GR @ 25 °C", "1.10 ± 0.02"],
                ["Dosage", "37% by weight of cement. Do not dilute with water."],
                ["Chloride Content", "Max 0.20%"],
                ["Setting Time", "30 to 60 seconds"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Priming">
          <Paragraph content="Vista Sealant Primer is recommended for surfaces such as concrete, brickwork, asbestos, cement, gypsum board, stone, glass, timber, rigid PVC, anodized aluminum, and ceramics. Priming is not required for epoxy or polyester surfaces." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaNoTwo;
